import Contact from "../components/Contact/Contact";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";

const ContactUs = () => {
    return (
        <>
            <Navbar />
            <Contact />
            <Footer />
        </>
    )
}

export default ContactUs;